/**
 * Helpers
 */
import EA from './helpers/init';
import UserAgent from './helpers/userAgent';

/* body class */
UserAgent.setBodyClass();

/**
 * Methods
 */
import './methods/exampleMethod.js';
import './methods/imageLazyLoad.js';
import './methods/videoLazyLoad.js';
import './methods/heroAnim.js';
import './methods/tabSwitchHandler.js';
import './methods/gallerySlider.js';
import './methods/textImageSlider.js';
import './methods/calcPagination.js';
import './methods/featuredArticlesSlider.js';
import './methods/headerDropdownHandler.js';
import './methods/mobileMenuHandler.js';
import './methods/animText.js';
import './methods/animFadeBottom.js';
import './methods/footerAnimFade.js';
import './methods/newsletterForm.js';

import { createApp } from 'vue';
import { defineAsyncComponent } from 'vue';

const app = createApp({
    mounted() {
        EA.loadMethods();
    }
});

/* Components */
app.component('ExampleComponent', defineAsyncComponent(() => import('../../components/ExampleComponent.vue')));
app.component('ContactForm', defineAsyncComponent(() => import('../../components/ContactForm.vue')));

/* Add Pinia store */
// import { createPinia } from 'pinia';
// const pinia = createPinia();
// app.use(pinia);

app.mount('#app');
